import Footer from "./Form.component";

export default Footer;
